export default __webpack_public_path__ + "static/media/Arrow drop down.eec32007.svg";